export * from './footer-page.component';